<template>
  <div class="user_used">
    <UserHead/>
    <UserNavi/>
    <div class="user_used_main">
      <div class="used_container" v-infinite-scroll="getLogs">
        <div class="used_head">
          当前权益
        </div>
        <div class="used_head_one" v-for="(sv,index) in orderSum" :key="index">
          <div class="used_head_title">
            {{sv.goods_title}}
          </div>
          <div class="used_head_count">
            <span style="color:red;">已用: {{sv.used}}</span> / <span style="color:blue;">总数:{{sv.counts}}</span>
          </div>
        </div>
        <div class="used_head">
          使用记录
        </div>
        <div class="used_head_info" v-for="item in logs" :key="item.utime" v-if="logs">
          <div class="used_head_info_one">
            <div class="used_head_info_title">
              {{item.goods_title}}
            </div>
            <div class="used_head_info_datetime">
              {{item.utime_str}} 使用
            </div>
          </div>
          <div class="used_head_info_one">
            <div class="used_head_info_name">
              {{item.shipname || item.mmsi || ''}}
            </div>
            <div class="used_head_info_exptimed" v-if="item.exp">
              {{item.exptime_str}} 过期
            </div>
            <div class="used_head_info_exptiming" v-else>
              {{item.exptime_str}} 过期
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getOrderSum,getUserAccesOrderLog } from '../../api/api'
  import { getJsonStorage } from "../../util/storage";
  import UserHead from './head'
  import UserNavi from './navi'

  export default {
    name: "UserUsed",
    components:{
      UserHead,
      UserNavi
    },
    data() {
      return {
        browserType: this.$browserType,
        user: getJsonStorage('openai_user'),
        orderSum: [],
        logs: [],
        page: 1,
        size: 10,
        loading:false
      }
    },
    mounted(){
      getOrderSum().then(res => {
        if(res && res.status === 0){
          this.orderSum = res.data;
        }
      });
      this.getLogs();
    },
    methods: {
      getLogs(){
        if(!this.loading) {
          this.loading = true;
          getUserAccesOrderLog(this.page, this.size).then(res => {
            if (res && res.status === 0 && res.data && res.data.length>0) {
              for (let d in res.data) {
                res.data[d]['utime_str'] = new Date(res.data[d]['utime'] * 1000).toLocaleString();
                res.data[d]['exptime_str'] = new Date(res.data[d]['exptime'] * 1000).toLocaleString();
                res.data[d]['exp'] = (new Date().valueOf() / 1000) > res.data[d]['exptime'];
                this.logs.push(res.data[d]);
              }
              this.loading = false;
              this.page++;
            }
          });
        }
      }
    }
  }
</script>

<style scoped>
  .user_used {
    top:6vh;
    left:0;
    position: absolute;
    height:94vh;
    width:100%;
    margin:0;
    overflow-y:hidden;
  }
  .user_used_main {
    width:94%;
    margin:1vh auto;
    padding:0;
    height:75vh;
    border:1px solid #ccc;
    border-radius: 1rem;
    overflow-y: scroll;
  }
  .used_container {
    width:90%;
    margin:1vh 5% 3vh 5%;
  }
  .used_head {
    color:rgb(56, 152, 235);
    height:2rem;
    line-height:2rem;
    font-weight: bold;
  }

  .used_head_one {
    width: 100%;
    font-size:.9rem;
    height:2rem;
    line-height:2rem;
    border-bottom:1px solid rgba(100,100,100,0.2)
  }

  .used_head_title {
    width:50%;
    float:left;
  }

  .used_head_count {
    width: 8rem;
    float:right;
    text-align: right;
    font-size:.8rem;
  }

  .used_head_info {
    width: 100%;
    font-size:.9rem;
    height:3rem;
    border-bottom:1px solid rgba(100,100,100,0.2)
  }

  .used_head_info_one {
    width: 100%;
    font-size:.9rem;
    height:1.5rem;
    line-height:1.5rem;
  }

  .used_head_info_title {
    height:1.5rem;
    line-height:1.5rem;
    width:50%;
    float:left;
    font-size:.7rem;
  }

  .used_head_info_name {
    height:1.5rem;
    line-height:1.5rem;
    width:50%;
    float:left;
    font-size:.7rem;
    color:rgb(56, 152, 235);
  }

  .used_head_info_datetime {
    width: 9rem;
    float: right;
    text-align: right;
    font-size:.7rem;
  }

  .used_head_info_exptimed {
    width: 9rem;
    float: right;
    text-align: right;
    font-size:.7rem;
    color:red;
  }

  .used_head_info_exptiming {
    width: 9rem;
    float: right;
    text-align: right;
    font-size:.7rem;
    color:green;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/used.vue